'use client';

import dynamic from 'next/dynamic';
import { BonusNotificationModal } from '@/entities/bonus-notification/ui/bonus-notification-modal';
import { CashbackModal } from '@/entities/cashback/ui/cashback-modal';
import { AuthManagementDynamic } from '@/features/auth-management/dynamic';
import { ModalPrompts } from '@/features/data-management/ui/modal-prompts';

const DynamicWalletManagement = dynamic(
  async () =>
    import('@/widgets/wallet-management').then((m) => m.WalletManagement),
  {
    ssr: false,
    loading: () => null,
  }
);

interface ModalVisibilityProps {
  onClose: () => void;
  visible: boolean;
}

interface AuthManagementProps extends ModalVisibilityProps {
  onOpen: () => void;
}

interface WalletManagementProps extends ModalVisibilityProps {
  initialStep?: 'deposit' | 'withdraw' | 'history-detail';
  onOpen: () => void;
}

interface GlobalModalsProps {
  authManagement: AuthManagementProps;
  cashbackModal: ModalVisibilityProps;
  mode: 'auth' | 'base';
  walletManagement?: WalletManagementProps;
}

export const GlobalModals = ({
  authManagement,
  cashbackModal,
  mode,
  walletManagement,
}: GlobalModalsProps) => {
  if (mode === 'base') {
    return (
      <>
        <CashbackModal
          visible={cashbackModal.visible}
          onClose={cashbackModal.onClose}
        />
        <AuthManagementDynamic
          onOpen={authManagement.onOpen}
          onClose={authManagement.onClose}
          visible={authManagement.visible}
        />
      </>
    );
  }

  return (
    <>
      <ModalPrompts />
      <AuthManagementDynamic
        onOpen={authManagement.onOpen}
        onClose={authManagement.onClose}
        visible={authManagement.visible}
      />
      {walletManagement?.visible && (
        <DynamicWalletManagement
          onOpen={walletManagement.onOpen}
          onClose={walletManagement.onClose}
          visible={walletManagement.visible}
          initialStep={walletManagement.initialStep}
        />
      )}
      <BonusNotificationModal />
      <CashbackModal
        visible={cashbackModal.visible}
        onClose={cashbackModal.onClose}
      />
    </>
  );
};
